<template>
  <div class="relative h-screen overflow-hidden">
    <NavBar />
    <div
      :class="['ml-20 flex h-full flex-col transition-all duration-300', { 'ml-80': navBar.shown }]"
    >
      <main
        class="flex flex-1 flex-col gap-4 overflow-auto px-4 py-2 pb-6 md:px-8 md:py-4 md:pb-12"
      >
        <LicenseAlert />
        <router-view />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import NavBar from '@/components/layouts/NavBar.vue'
import LicenseAlert from '@/components/license/LicenseAlert.vue'
import { useNavBarStore } from '@/stores/NavBarStore'
import { onMounted, ref } from 'vue'
import { RouterView } from 'vue-router'

import SystemWarnings from './SystemWarnings.vue'

const navBar = useNavBarStore()

let warningShownThisSession = false
const showWarning = ref(false)

onMounted(() => {
  if (warningShownThisSession) return
  const dismissed = localStorage.getItem('warningDismissed')
  if (dismissed !== 'true') {
    showWarning.value = true
    warningShownThisSession = true
  }
})
function handleDismiss() {
  localStorage.setItem('warningDismissed', 'true')
  showWarning.value = false
}
</script>
